import React from 'react';

function FloatingWhatsApp({ client }) {
    const openWhatsApp = () => {
        const phoneNumber = client?.configuration?.whatsapp_number;
        const defaultMessage = 'Hola, necesito soporte';
        const message = client?.configuration?.whatsapp_text || defaultMessage;
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    if (!client?.configuration?.whatsapp_number) {
        return null;
    }

    return (
        <button
            className="btn btn-success rounded-circle shadow-lg position-fixed d-flex align-items-center justify-content-center"
            style={{
                bottom: '80px',
                right: '20px',
                width: '50px',
                height: '50px',
                zIndex: 1000
            }}
            onClick={openWhatsApp}
        >
            <i className="bi bi-whatsapp fs-5"></i>
        </button>
    );
}

export default FloatingWhatsApp; 